import { render, staticRenderFns } from "./MultiselectField.vue?vue&type=template&id=2ed731d5&scoped=true&"
import script from "./MultiselectField.vue?vue&type=script&lang=js&"
export * from "./MultiselectField.vue?vue&type=script&lang=js&"
import style0 from "./MultiselectField.vue?vue&type=style&index=0&id=2ed731d5&prod&scoped=true&style=scss&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed731d5",
  null
  
)

export default component.exports